import React from "react";
import WhistleSvg from "../assets/whistle.svg";
import BasketballSvg from "../assets/basketball.svg";
import OvertimeSvg from "../assets/overtime.svg";

const defaultProps = { style: { width: "4vw", height: "4vw" } };

export const makeBasketballTimelineIcons = (
  imgProps: React.ImgHTMLAttributes<HTMLImageElement> = defaultProps
) => ({
  whistle: <img src={WhistleSvg} alt="Whistle" {...imgProps} />,
  period_bucket: <img src={BasketballSvg} alt="Period" {...imgProps} />,
  overtime: <img src={OvertimeSvg} alt="Overtime" {...imgProps} />,
});

const BASKETBALL_TIMELINE_ICONS = makeBasketballTimelineIcons();
export default BASKETBALL_TIMELINE_ICONS;
